//@import dependencies
import React, {useState, useEffect, CSSProperties, FocusEvent} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
import IconComponent from 'app_components/commons/icons'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
import CourseSchedulingStatusService from 'app_services/admin/courseScheduling/courseSchedulingStatusService'
import CourseSchedulingTypeService from 'app_services/admin/courseScheduling/courseSchedulingTypeService'
import CourseSchedulingModeService from 'app_services/admin/courseScheduling/courseSchedulingModeService'
import RegionalService from 'app_services/admin/regional/regionalService'
import ModularService from 'app_services/admin/modular/modularService'
import CompanyService from 'app_services/admin/company/companyService';
// @end

// @INFO Import Styles
import './../courseSchedulingScreen.scss'

// @ADD Component types

type TypesFieldsFilterCourseScheduling =
'service_id' |
'program_course_name' |
'course_scheduling_code' |
'teacher' |
'modular' |
'mode' |
'schedulingType' |
'schedulingStatus' |
'regional' |
'company' |
'companies_executive' |
'client' |
'start_date' |
'end_date' |
'schedulingAssociation'
;

interface ICourseSchedulingScreenFormFilterLayoutProps {
  searchForm: any
  onSearch: () => void
  onClear?: () => void
  searchFormInputs?: any
  className?: string
  style?: CSSProperties
  fields?: TypesFieldsFilterCourseScheduling[]
  executiveId?: string
}

const CourseSchedulingScreenFormFilterLayout: React.FC<ICourseSchedulingScreenFormFilterLayoutProps> = (props) => {

  const {searchForm} = props

  // @Import services
  const courseSchedulingStatusService: CourseSchedulingStatusService = new CourseSchedulingStatusService()
  const courseSchedulingTypeService: CourseSchedulingTypeService = new CourseSchedulingTypeService()
  const courseSchedulingModeService: CourseSchedulingModeService = new CourseSchedulingModeService()
  const regionalService: RegionalService = new RegionalService()
  const modularService: ModularService = new ModularService()
  const companyService: CompanyService = new CompanyService()
  // const courseSchedulingService: CourseSchedulingService = new CourseSchedulingService()

  const [listOfStatus, setListOfStatus] = useState<Array<any>>([])
  const [listOfTypes, setListOfTypes] = useState<Array<any>>([])
  const [listOfCourseModes, setListOfCourseModes] = useState<Array<any>>([])
  const [listOfRegionals, setListOfRegionals] = useState<Array<any>>([])
  const [listOfModulars, setListOfModulars] = useState<Array<any>>([])
  const [listOfCompanies, setListOfCompanies] = useState<Array<any>>([])
  const [listOfCompaniesExecutive, setListOfCompaniesExecutive] = useState<Array<any>>([])

  // const searchForm = useForm()
  const [colors] = useColors()

  const { t } = useTranslation()

  useEffect(() => {
    if (!props.fields || props.fields.includes('schedulingStatus'))
    getStatus()
    if (!props.fields || props.fields.includes('mode'))
    getCourseModes()
    if (!props.fields || props.fields.includes('schedulingType'))
    getTypes()
    if (!props.fields || props.fields.includes('regional'))
    getRegionals()
    if (!props.fields || props.fields.includes('modular'))
    getModulars()
    if (!props.fields || props.fields.includes('company'))
    getClients()
    if (!props.fields || props.fields.includes('companies_executive'))
    getCompaniesExecutive()
  }, [])

  const getStatus = async () => {
    const items: Array<any> = []
    const response = await courseSchedulingStatusService.list()
    if (response?.courseSchedulingStatuses) {
      response.courseSchedulingStatuses.map((item: any) => {
       items.push({ value: item._id, label: item.name })
      })
    }
    setListOfStatus(items)
  }

  const getClients = async () => {
    const items: Array<any> = []
    const response = await companyService.list()
    if (response?.companies) {
      response?.companies.map((item: any) => {
        items.push({ value: item._id, label: item.name })
      })
    }
    setListOfCompanies(items)
  }

  const getCompaniesExecutive = async () => {
    const items: Array<any> = []
    if (!props.executiveId) return
    const response = await companyService.fetchCompaniesExecutiveByUser({ userId: props.executiveId })
    if (response?.companies) {
      response?.companies.map((item: any) => {
        items.push({ value: item._id, label: item.name })
      })
      items.sort((item1, item2) => item1.label.localeCompare(item2.label))
    }
    setListOfCompaniesExecutive(items)
  }

  const getCourseModes = async () => {
    const types: Array<any> = []
    const courseModesResponse = await courseSchedulingModeService.list({moodle_id: true})
    if (courseModesResponse) {
      courseModesResponse.courseSchedulingModes.map((type: any) => {
        types.push({ value: type._id, label: type.name })
      })
    }
    setListOfCourseModes(types)
  }

  const getTypes = async () => {
    const items: Array<any> = []
    const response = await courseSchedulingTypeService.list()
    if (response?.courseSchedulingTypes) {
      response?.courseSchedulingTypes.map((item: any) => {
       items.push({ value: item._id, label: item.name })
      })
    }
    setListOfTypes(items)
  }

  const getRegionals = async () => {
    const regionals: Array<any> = []
    const regionalResponse = await regionalService.list()
    if (regionalResponse?.regionals) {
      regionalResponse.regionals.map((regional: any) => {
        regionals.push({ value: regional._id, label: regional.name })
      })
    }
    setListOfRegionals(regionals)
  }

  const getModulars = async () => {
    const items: Array<any> = []
    const response = await modularService.list()
    if (response?.modulars) {
      response.modulars.map((item: any) => {
       items.push({ value: item._id, label: item.name })
      })
    }
    setListOfModulars(items)
  }

  const handleOnFocus = (e: FocusEvent<HTMLInputElement>) => {
    e.currentTarget.type = "date";
  }

  const handleOnBlur = (e: FocusEvent<HTMLInputElement>) => {
      e.currentTarget.type = "text";
  }

  const handleClickClear = () => {
    if (props.onClear) {
      props.onClear()
    } else {
      props.onSearch()
    }
  }

  return(
    <div
      className={`form-filter ${props.className ? props.className : ''}`}
      style={props.style}
    >
      <h3>Filtros</h3>
      <form className='mb-3 mt-3' onSubmit={searchForm.handleSubmit(props.onSearch)}>
        <div className="row g-3">
          {!props.fields || props.fields.includes('program_course_name') ?
          <div className="col-3 mb-3">
            <input
              className='form-control search-input'
              type='text'
              name='program_course_name'
              id='program_course_name'
              placeholder={t('screens.course_scheduling.search.program_course_name')}
              defaultValue={props?.searchFormInputs?.program_course_name}
              ref={searchForm.register()}
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('modular') ?
          <div className="col-md-3">
              <ReactSelectComponent
                identifier='modular'
                options={listOfModulars}
                formHooks={searchForm}
                defaultValue={(props?.searchFormInputs?.modular) ? [props?.searchFormInputs?.modular] : []}
                isMulti={false}
                required={false}
                placeholder={t('labels.course_scheduling.modular')}
              />
          </div>
          :null}

          {!props.fields || props.fields.includes('service_id') ?
          <div className="col-3 mb-3">
            <input
              className='form-control search-input'
              type='text'
              name='service_id'
              id='service_id'
              placeholder={t('screens.course_scheduling.search.service')}
              defaultValue={props?.searchFormInputs?.service_id}
              ref={searchForm.register()}
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('course_scheduling_code') ?
          <div className="col-3 mb-3">
            <input
              className='form-control search-input'
              type='text'
              name='course_scheduling_code'
              id='course_scheduling_code'
              placeholder={t('screens.course_scheduling.search.code')}
              defaultValue={props?.searchFormInputs?.course_scheduling_code}
              ref={searchForm.register()}
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('mode') ?
          <div className="col-3 mb-3">
            <ReactSelectComponent
              identifier='mode'
              options={listOfCourseModes}
              formHooks={searchForm}
              defaultValue={(props?.searchFormInputs?.mode) ? [props?.searchFormInputs?.mode] : []}
              isMulti={false}
              required={false}
              placeholder={t('labels.course_scheduling.schedulingMode')}
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('schedulingType') ?
          <div className="col-3 mb-3">
            <ReactSelectComponent
              identifier='schedulingType'
              options={listOfTypes}
              formHooks={searchForm}
              defaultValue={(props?.searchFormInputs?.schedulingType) ? [props?.searchFormInputs?.schedulingType] : []}
              isMulti={false}
              required={false}
              placeholder={t('labels.course_scheduling.schedulingType')}
            />
          </div>
          :null}
          {!props.fields || props.fields.includes('schedulingStatus') ?
          <div className="col-3 mb-3">
            <ReactSelectComponent
              identifier='schedulingStatus'
              options={listOfStatus}
              formHooks={searchForm}
              defaultValue={(props?.searchFormInputs?.schedulingStatus) ? [props?.searchFormInputs?.schedulingStatus] : []}
              isMulti={false}
              required={false}
              placeholder={t('labels.course_scheduling.schedulingStatus')}
            />
          </div>
          :null}
          {!props.fields || props.fields.includes('regional') ?
          <div className="col-3 mb-3">
            <ReactSelectComponent
              identifier='regional'
              options={listOfRegionals}
              formHooks={searchForm}
              defaultValue={(props?.searchFormInputs?.regional) ? [props?.searchFormInputs?.regional] : []}
              isMulti={false}
              required={false}
              placeholder={t('labels.course_scheduling.regional')}
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('company') ?
          <div className="col-3 mb-3">
            <ReactSelectComponent
              identifier='company'
              options={listOfCompanies}
              formHooks={searchForm}
              defaultValue={(props?.searchFormInputs?.client) ? [{ value: props?.searchFormInputs?.client?._id, label: props?.searchFormInputs?.client?.name }] : []}
              isMulti={false}
              required={true}
              placeholder="Empresa"
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('companies_executive') ?
          <div className="col-3 mb-3">
            <ReactSelectComponent
              identifier='company'
              options={listOfCompaniesExecutive}
              formHooks={searchForm}
              defaultValue={(props?.searchFormInputs?.client) ? [{ value: props?.searchFormInputs?.client?._id, label: props?.searchFormInputs?.client?.name }] : []}
              isMulti={false}
              required={false}
              placeholder="Empresa"
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('client') ?
          <div className="col-3 mb-3">
            <input
              id='client'
              name='client'
              className={`form-control`}
              type='text'
              ref={searchForm.register({ required: false })}
              defaultValue={props?.searchFormInputs?.client}
              placeholder={t('labels.course_scheduling.client')}
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('schedulingAssociation') ?
          <div className="col-3 mb-3">
            <input
              id='schedulingAssociation'
              name='schedulingAssociation'
              className={`form-control`}
              type='text'
              ref={searchForm.register({ required: false })}
              defaultValue={props?.searchFormInputs?.schedulingAssociation}
              placeholder={t('labels.course_scheduling.schedulingAssociation')}
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('start_date') ?
          <div className="col-3 mb-3">
            <input
              id='start_date'
              name='start_date'
              className={`form-control`}
              type='text'
              ref={searchForm.register({ required: false })}
              defaultValue={props?.searchFormInputs?.start_date}
              placeholder={t('screens.course_scheduling.search.start_date')}
              onFocus={handleOnFocus}
              onBlur={handleOnBlur}
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('end_date') ?
          <div className="col-3 mb-3">
            <input
              id='end_date'
              name='end_date'
              className={`form-control`}
              type='text'
              ref={searchForm.register({ required: false })}
              defaultValue={props?.searchFormInputs?.end_date}
              placeholder={t('screens.course_scheduling.search.end_date')}
              onFocus={handleOnFocus}
              onBlur={handleOnBlur}
            />
          </div>
          :null}

          {!props.fields || props.fields.includes('teacher') ?
          <div className="col-3 mb-3">
            <input
              id='teacher'
              name='teacher'
              className={`form-control`}
              type='text'
              ref={searchForm.register({ required: false })}
              defaultValue={props?.searchFormInputs?.teacher}
              placeholder={t('screens.course_scheduling.search.teacher')}
            />
          </div>
          :null}

          <div className="col-12 mt-3 text-right">
            <button type="submit" className="btn btn-primary">
              Buscar
            </button>
            &nbsp;&nbsp;&nbsp;
            <button type="button" className="btn btn-secondary" onClick={handleClickClear}>
              Limpiar
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default CourseSchedulingScreenFormFilterLayout
